import { render } from "./MemberSetPassword.vue?vue&type=template&id=0832ae13&scoped=true"
import script from "./MemberSetPassword.vue?vue&type=script&lang=js"
export * from "./MemberSetPassword.vue?vue&type=script&lang=js"

import "./MemberSetPassword.vue?vue&type=style&index=0&id=0832ae13&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0832ae13"]])

export default __exports__